<template>
	<div>
		<!-- @vue-expect-error -->
		<div
			:data-cloned-from-id="cloneParams.cloned_from_id"
			:id='"j-game-clone-worker-item-" + jobId'
		>
			<h4><!-- @vue-expect-error --> {{ cloneParams.name }}</h4>
			<!-- @vue-expect-error -->
			<a :href='"/games/" + cloneParams.cloned_from_id'>{{
				t("activerecord.models.game_template.one")
			}}</a>
			<br>
			<strong>{{ t("activerecord.models.game_token.one") }}:</strong>
			<a v-if="gameToken" :href='"/game_tokens/" + gameToken'>{{
				gameToken
			}}</a>
			<span v-if="!gameToken">&mdash;</span>
			<br>
			<strong>{{ t("activerecord.attributes.phase.start_date") }}:</strong>
			<!-- @vue-expect-error -->
			{{ cloneParams.start_date }}
			<br>
			<strong>
				<!-- @vue-expect-error -->
				{{
					t("activerecord.models.actor", {
						count: cloneParams.actor_tpl_ids.length - 1,
					})
				}}
				:</strong
			>
			<!-- @vue-expect-error -->
			{{ cloneParams.actor_tpl_ids.length - 1 }}
			<br>
			<strong>{{ t("backend.game_clone_enqueued_at") }}:</strong>
			{{ enqueuedAt }}
			<br>
			<strong v-html="cloningStatus"></strong>
			<br>
			<strong class="j-cloned-game-link" v-if="gameLink">
				<a :href="gameLink" class="button">{{
					t("helpers.submit.created", {
						model: t("activerecord.models.game.one"),
					})
				}}</a>
			</strong>
			<hr>
		</div>
	</div>
</template>

<script>
// Other components
import { i18n } from "../utils";

export default {
	mixins: [i18n],
	props: {
		srvJobId: Object,
		srvCloneParams: Object,
		srvGameToken: String,
		srvUserId: String,
		srvEnqueuedAt: String,
		srvFayeSubscription: Object,
	},
	data: function () {
		return {
			jobId: this.srvJobId,
			cloneParams: this.srvCloneParams,
			gameToken: this.srvGameToken == "null" ? null : this.srvGameToken,
			userId: this.srvUserId,
			fayeSubscription: this.srvFayeSubscription || null,
			// @ts-expect-error
			enqueuedAt: new Date(parseInt(this.srvEnqueuedAt) * 1000),
			cloningStatus: "⌛",
			gameLink: "",
		};
	},
	computed: {},
	mounted() {
		// pp.log("mounted", this.srvCloneParams, this.srvEnqueuedAt, this.srvFayeSubscription, this.srvGameToken);
		if (this.fayeSubscription) {
			PrivatePub.sign(this.fayeSubscription);
			const vueInstance = this;
			PrivatePub.subscribe(
				// @ts-expect-error
				this.fayeSubscription.channel,
				function (data, channel) {
					if (data === undefined) {
						return;
					}

					// pp.log("data", data, i18n);
					if (data.message !== undefined) {
						vueInstance.cloningStatus = data.message;
					}
					if (data.redirect_url !== undefined) {
						// @ts-expect-error
						vueInstance.cloningStatus = undefined;
						vueInstance.gameLink = data.redirect_url;
					} else if (data.warnings !== undefined) {
						vueInstance.cloningStatus = `${I18n.t("backend.game_cloning_fields.flash.game_was_cloned_with_warnings")}<br>${data.warnings.join("<br>")}`;
					} else if (data.errors !== undefined) {
						vueInstance.cloningStatus = `${I18n.t("backend.game_cloning_fields.flash.game_was_cloned_with_errors")}<br>${data.errors.join("<br>")}`;
					}
				},
			);
		}
	},
	methods: {},
};
</script>
